import { BrandBgEntity, RoomId, roomId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomBrandBgDeleteRequestDTO {
  private static validation = JsonSchemaValidator.compile(
    RoomBrandBgDeleteRequestDTO.validationSchema(),
    BrandBgEntity
  );

  constructor(readonly data: RoomBrandBgDeleteRequest) {
    JsonSchemaValidator.assert(RoomBrandBgDeleteRequestDTO.validation, data);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "brandBg"],
      properties: {
        roomId,
        brandBg: {
          instanceof: BrandBgEntity.name
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomBrandBgDeleteRequest {
  roomId: RoomId;
  brandBg: BrandBgEntity;
}
